
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { capitalizeFirstLetter, checkCRUDViewPermission } from '../../../../../helpers/utilities';
import { useParams } from "react-router-dom";
import { CustomForm } from './CustomForm';
import { emptyValidation, customAadharValidation } from "../../../../../helpers/validation";
import { useDispatch, useSelector } from "react-redux";
import { AESDecrypt, AESEncrypt } from "../../../../../helpers/Crypto";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import actions from "../../redux/actions";
import { toast } from 'react-toastify';


const PlanCreate = (props) => {
    const { createDetails, createError, editDetails, editError, createData, editLoader, createLoader, readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const [showDetails, setShowDetails] = useState(true);
    const { type } = useParams();
    const childRef = useRef('');
    const [form, setForm] = useState({ checkStatus: true, startDate: new Date(), endDate: new Date() });
    const [error, setError] = useState({});
    const dispatch = useDispatch();
    let { subscriptionPlanId } = useParams();
    const decryptedId = AESDecrypt(subscriptionPlanId);
    const prevReadDetails = usePrevious(readDetails);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Plan Details', type, history, 'Younote Admin')) {
            if (subscriptionPlanId && decryptedId === 0) {
                history.push('/younote-admin/common/plan-details')
            } else {
                loadTask();
            }
        }
    }, [subscriptionPlanId, type, roleManagement]);


    const loadTask = () => {
        dispatch({
            type: actions.PROVIDER_DETAILS_START, filter: {
                order: 'id desc',
            }
        });
        if (subscriptionPlanId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "plans" });
        } else {
            setShowDetails(false);
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(`"${createData.planId}" has been added successfully`);
            history.push(`/younote-admin/common/plan-details/${AESEncrypt(createData.id)}/view`, 'create');
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            setError({
                planId: createError.error.message
            });
        }
        childRef?.current?.handleAdjustHeight();
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(`"${form.planId}" has been updated successfully`);
            history.push(`/younote-admin/common/plan-details/${AESEncrypt(form.id)}/view`, 'edit');
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            setError({
                planId: editError.error.message
            });
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (readDetails?.status) {
                readDetails.checkStatus = readDetails?.status === 'ACTIVE' ? true : false
            }
            setForm(readDetails);
            setError({});
        } else if (readError) {
            if (readError.error.statusCode) {
                toast('Subscription Plan is invalid');
                history.push('/younote-admin/common/plan-details');
            }
        }
    }, [readDetails, readError]);

    const submitPlan = (e) => {
        e.preventDefault();
        let emptyPlanId = emptyValidation('Plan ID', form?.planId);
        let emptyName = emptyValidation('Plan Name', form?.planName);
        let emptyActualPlanAmount = customAadharValidation('Actual Plan Amount', form?.actualPlanAmount);
        let emptyPlanAmount = customAadharValidation('Plan Amount', form?.planAmount);
        let emptyAllowedUser = emptyValidation('Allowed User', form?.allowedUsers);
        let emptyProviderId = emptyValidation('Provider', form?.providerId, 'dropDown');
        let emptyPlanType = emptyValidation('Plan Type', form?.planType, 'dropDown');
        let emptyFrequecy = emptyValidation('Frequency', form?.frequency, 'dropDown');
        let emptyStartDate = emptyValidation('Start Date', form?.startDate);
        let emptyEndDate = emptyValidation('End Date', form?.endDate);
        if (emptyPlanId.isValid && emptyName.isValid && emptyActualPlanAmount.isValid && emptyPlanAmount.isValid
            && emptyAllowedUser.isValid && emptyStartDate.isValid && emptyEndDate.isValid && emptyAllowedUser.isValid && emptyProviderId.isValid &&
            emptyPlanType.isValid && emptyPlanType.isValid && emptyFrequecy.isValid
        ) {
            form.actualPlanAmount = parseFloat(form.actualPlanAmount);
            form.planAmount = parseFloat(form.planAmount);
            form.allowedUsers = parseFloat(form.allowedUsers);
            delete form.provider;
            if (form?.checkStatus) {
                form.status = 'ACTIVE'
            } else {
                form.status = 'INACTIVE'
            }
            delete form.checkStatus;
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: form.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "plans",
                id: form.id,
                title: "Subscription Plans",
                details: data
            })
        } else {
            setError({
                'planId': emptyPlanId?.errors,
                'planName': emptyName?.errors,
                'actualPlanAmount': emptyActualPlanAmount?.errors,
                'planAmount': emptyPlanAmount?.errors,
                'allowedUsers': emptyAllowedUser?.errors,
                'providerId': emptyProviderId?.errors,
                'planType': emptyPlanType?.errors,
                'frequency': emptyFrequecy?.errors,
                'startDate': emptyStartDate?.errors,
                'endDate': emptyEndDate?.errors
            })
        }

    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'providerId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    'provider': e,
                });
            } else if (name === 'checkStatus') {
                setForm({
                    ...form,
                    [name]: e
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }

        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    const handleSync = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "plans",
            id: form.id,
            method: "put",
            title: "Subscription Plans",
        })
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                img={SettingsImg}
                title={'Product'}
                type={type}
                links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Younote Admin', 'link': '/younote-admin' },
                { 'label': 'Plan Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, 
                classes.listTableMargin, classes.listTableSticky)}>
                <div className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={`${capitalizeFirstLetter(type === 'create' ? 'Add' : type)} Plan Details`}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        height={'calc(100vh - 221px)'}
                        component={
                            !showDetails ? <CustomForm
                                type={type}
                                handleSync={() => handleSync()}
                                form={form}
                                error={error}
                                readDetails={readDetails}
                                createLoader={createLoader}
                                editLoader={editLoader}
                                changeHandler={(e, name = '') => changeHandler(e, name)} submitPlan={(e) => submitPlan(e)} /> : <div className={classes.textAlignCenter}><div className={classes.loadMoreCircle}></div></div>
                        }
                    />
                </div>
            </div>
        </React.Fragment>
    )
}


export default PlanCreate;